import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.5 13.5L1.5 14.5C1.5 16.1569 2.84315 17.5 4.5 17.5L14.5 17.5C16.1569 17.5 17.5 16.1569 17.5 14.5L17.5 13.5M13.5 9.5L9.5 13.5M9.5 13.5L5.5 9.5M9.5 13.5L9.5 1.5",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }